export { parseAllVariableTags, variableAttrsToDataAttrs, escapeHtml } from "@equaliq/api-model"

// Stub — contracts are not yet in the Smithy api-model
export interface GetContractResponseContent {
  id: string;
  title?: string;
  status?: string;
  fileId?: string;
  content?: string;
  metadata?: Record<string, unknown>;
  [key: string]: unknown;
}

// Legacy contract-analysis types — not yet in the Smithy-generated api-model.
// Defined locally for demo/prototype features until the contract-intelligence
// domain is formalized in the API model.

export enum ContractStatus {
  draft = "draft",
  active = "active",
  completed = "completed",
  cancelled = "cancelled",
  expired = "expired",
}

// EQ Card keys MUST match the @equaliq/api-model schema the backend
// serializes (getContract → adaptEqCards emits exactly these keys). The
// prior values (paymentTerms/exclusivity/…) were a stale pre-api-model
// placeholder that NO consumer referenced — every call site already uses
// .moneyYouReceive…risksCostsLegalStuff, so against the old enum they all
// resolved to `undefined` and EQ cards rendered "No data available".
export enum EqCardKey {
  moneyYouReceive = "moneyYouReceive",
  whatYouOwn = "whatYouOwn",
  whatYoureResponsibleFor = "whatYoureResponsibleFor",
  howLongThisDealLasts = "howLongThisDealLasts",
  risksCostsLegalStuff = "risksCostsLegalStuff",
}

// Card layout variant — matches api-model EqCardType ("A" | "B"). The old
// financial/legal/operational members were likewise stale and unreferenced.
export enum EqCardType {
  A = "A",
  B = "B",
}

export enum DurationType {
  days = "days",
  months = "months",
  years = "years",
}

export enum IqModeSectionKey {
  summary = "summary",
  obligations = "obligations",
  risks = "risks",
  recommendations = "recommendations",
}

export enum ContractVariableType {
  text = "text",
  number = "number",
  date = "date",
  currency = "currency",
  percentage = "percentage",
  boolean = "boolean",
}

export interface ContractVariable {
  key: string;
  label: string;
  type: ContractVariableType;
  value?: string;
  description?: string;
}

export type ContractVariableMap = Record<string, ContractVariable>;

export interface IqModeSection {
  key: IqModeSectionKey;
  title: string;
  content: string;
}

export interface ContractMetadata {
  id: string;
  contractId?: string;
  title: string;
  name?: string;
  type?: string;
  status: ContractStatus;
  createdAt: string;
  updatedAt: string;
  parties?: string[];
  tags?: string[];
}

export interface ContractAnalysisProps {
  providedContract?: GetContractResponseContent
}

export type ContractAnalysisMode = "eq" | "iq"

// Stub request/response types for contract CRUD (not yet in Smithy)
export type ListContractsRequestContent = { orgId?: string };
export type ListContractsResponseContent = { contracts: GetContractResponseContent[] };
export type DeleteContractResponseContent = { success: boolean };
export type ShareContractResponseContent = { success: boolean };
export type UpdateContractResponseContent = GetContractResponseContent;
export type GetUploadURLResponseContent = { uploadUrl: string; fileId: string };

export interface DemoContract {
  contractId: string;
  name: string;
  type: string;
  status?: ContractStatus;
  [key: string]: unknown;
}
